import { apiHelpFeedback } from "@/api/help-feedback.api.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { ApiErrorException } from "@/types/api.types.ts";
import {
  ApiHelpFeedbackCommentSave,
  ApiHelpFeedbackRatingSave,
} from "@/types/help-feedback.types.ts";
import { useMutation } from "@tanstack/react-query";

export const useHelpFeedbackSaveRating = () => {
  const { onError } = useErrorHandle();

  return useMutation({
    mutationFn: async (payload: ApiHelpFeedbackRatingSave) => {
      const result = await apiHelpFeedback.saveRating(payload);
      if (result.error || !result.data) throw new ApiErrorException(result.error);
      return result.data;
    },
    onError: (error: Error) => {
      onError(error);
    },
  });
};

export const useHelpFeedbackSaveComment = () => {
  const { onError } = useErrorHandle();

  return useMutation({
    mutationFn: async (payload: ApiHelpFeedbackCommentSave) => {
      const result = await apiHelpFeedback.saveComment(payload);
      if (result.error || !result.data) throw new ApiErrorException(result.error);
      return result.data;
    },
    onError: (error: Error) => {
      onError(error);
    },
  });
};
